import type { PartnerSchemaType } from '@/types/portal-api.generated'

export type CachedPartnerFeatureFlag = {
  name: string
  value: unknown
}

export type CachedPartner = {
  partnerId: string
  partnerName: string
  canPlaceOrder: boolean
  isUsingPatientPortal: boolean
  isRegisteredByPatient: boolean
  startDate?: string | null
  endDate?: string | null
  status?: PartnerSchemaType['status']
  featureFlags?: CachedPartnerFeatureFlag[]
}

export function mapPartnerToCachedPartner(partner: PartnerSchemaType): CachedPartner {
  return {
    partnerId: partner.partner_id,
    partnerName: partner.partner_name,
    canPlaceOrder: partner.client_portal_order_placement,
    isUsingPatientPortal: partner.patient_portal,
    isRegisteredByPatient: partner.kit_registration_by_patient,
    startDate: partner.start_date,
    endDate: partner.end_date,
    status: partner.status,
    featureFlags: partner.feature_flags || [],
  }
}

const CACHE_KEY = 'partnersData'

export const PARTNERS_DATA_UPDATED_EVENT = 'partnersDataUpdated'

export function setPartnersCache(partners: CachedPartner[]): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(partners))
    window.dispatchEvent(new Event(PARTNERS_DATA_UPDATED_EVENT))
  } catch {
    // ignore
  }
}

export function getPartnersCache(): CachedPartner[] | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return null
    return parsed as CachedPartner[]
  } catch {
    return null
  }
}

export function clearPartnersCache(): void {
  try {
    localStorage.removeItem(CACHE_KEY)
    window.dispatchEvent(new Event(PARTNERS_DATA_UPDATED_EVENT))
  } catch {
    // ignore
  }
}
